import React from "react";

const Successfull = ({ company_name = "Company Name", invoice_url = '', amount = 0, plan, subscription, invoice_data = [], amount_paid = 0 }) => {
  const downloadInvoice = (url) => {
    window.location.assign(url);
  }

  const formatDateRange = (startIso, endIso) => {
    if (!startIso || !endIso) {
      return null;
    }

    const start = new Date(startIso);
    const end = new Date(endIso);

    const startDay = start.getDate();
    const startMonth = start.toLocaleString('en-US', { month: 'short' });

    const endDay = end.getDate();
    const endMonth = end.toLocaleString('en-US', { month: 'short' });
    const endYear = end.getFullYear();

    return `${startMonth} ${startDay} – ${endMonth} ${endDay}, ${endYear}`;
  }

  const invoiceTitle = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long'
  }).format(new Date(subscription.current_period_start || Date.now()))

  const totalDiscount = (data) => {
    let total = 0;
    data.map(ele => {
      if(ele?.discount_amounts){
        ele?.discount_amounts.map(item =>{
          total = total + item?.amount;
        })
      }
    })
    return total
  }

  return (
    <div className="page">
      <div className="card-title">Thanks for using UserNurture</div>
      <p className="details">
        Your {plan?.interval === 'month' ? invoiceTitle : `${new Date(subscription.current_period_start || Date.now()).getFullYear()}`} invoice is now available for team:{" "}
        <span>{company_name}</span>. The balance was automatically charged to
        your credit card, so you don’t need to do anything.
      </p>
      <p className="item-title">Summary for {company_name}</p>
      <ul className="list-group item-list">
        {invoice_data.map(item => {
          const periodLabel = formatDateRange(item?.period?.start * 1000, item?.period?.end * 1000)

          return(
            <li className="list-group-item" key={`${item?.description}-${item?.amount}`}>
              {item?.description}<br/>
              {periodLabel}
              <span className="price">$ {(item.amount/100).toFixed(2)}</span>
            </li>            
          )
        })}
        <li className="list-group-item total-price">
          Total discount
          <span className="price">- $ {(totalDiscount(invoice_data)/100).toFixed(2)}</span>
        </li>
        <li className="list-group-item total-price">
          Amount paid
          <span className="price">$ {(amount_paid/100).toFixed(2)}</span>
        </li>
        {/* <li className="list-group-item">
          Usage charges for {`${plan?.name}`}<br/>
          {formatDateRange(subscription.current_period_start, subscription.current_period_end)}
          <span className="price">$ {(amount/100).toFixed(2)}</span>          
        </li>
        <li className="list-group-item total-price">
          Amount paid
          <span className="price">$ {(amount/100).toFixed(2)}</span>
        </li> */}
      </ul>
      {invoice_url && (
        <div style={{ display: "contents" }}>
          <div className="btn btn-blue view-invoice" onClick={() => downloadInvoice(invoice_url)}>View Invoice</div>
        </div>
      )}
    </div>
  );
};

export default Successfull;
